import legislationCreate from './legislationCreate';
import legislationSelect from './legislationSelect';
import legislationAudit from './legislationAudit';
import entringResult from './entringResult';
import auditResult from './auditResult';

export default {
    legislationCreate,
    legislationSelect,
    legislationAudit,
    entringResult,
    auditResult,
}